export default __webpack_public_path__ + "static/media/chapter10.59eff72f.jpg";